export enum WALLET_TYPES {
  SODEXO = 'sodexo',
}
